import { Component } from '@angular/core';
import { VillageService } from 'src/app/services/village.service';
import {ThemePalette} from '@angular/material/core';
import { FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { MainGatesComponent } from '../main-gates/main-gates.component';
import { MatDialogRef } from '@angular/material/dialog';
import { UnitsService } from 'src/app/services/units.service';

@Component({
  selector: 'app-add-qr-config',
  templateUrl: './add-qr-config.component.html',
  styleUrls: ['./add-qr-config.component.css']
})
export class AddQrConfigComponent {

  village_list:any
  color: ThemePalette = "primary";
  checked = false;
  Village_form :FormGroup | any;
  types_arr:any

  constructor(private villageSer : VillageService , 
    private unitServ : UnitsService,
     public dialogRef: MatDialogRef<MainGatesComponent>,){}

  ngOnInit(){
    this.allVillage()
    this.initForm()
    this.qr_type()
  }
  initForm(){
    this.Village_form = new FormGroup({
      villages: new FormControl("", [Validators.required]),
      qr_type_id: new FormControl("" ,[Validators.required]),
      one_time_use: new FormControl(""),
      started: new FormControl(""),
      ended: new FormControl(""),
      full_day_access: new FormControl(""),
      '30_seconds': new FormControl(""),
      start_time: new FormControl(""),
      count :  new FormControl(""),
      available_days : new FormControl("")
    })
  }

  qr_type(){
    this.unitServ.qrtypes().subscribe((res: any) => {
      console.log(res)
      this.types_arr = res.children
    })
  }

  allVillage(){
    this.villageSer.villageList().subscribe((res:any) => {
      console.log(res)
      this.village_list = res
    })
  }
  add_user_config(){
    let data = this.Village_form.value
    console.log(data)
     this.dialogRef.close(data)
  }
}
